import initVueApp from "@/core.js";
const component = require(`./../views/Sourcing.vue`).default;
initVueApp(component);
